/** Production bug fix (2026-10) — `shoot_dates` is a plain formatted STRING for a
 * Notion-synced project, but `_validate_date_field` (backend modules/projects.py) stores it
 * as a RAW {start,end} OBJECT whenever it's set/edited through this app's own date-range
 * picker (create/update project — never reformatted back to a string). Rendering that object
 * directly as a React child threw "Objects are not valid as a React child", and with no error
 * boundary around the route this unmounted the ENTIRE app — a blank page, sidebar included —
 * for every newly-created-or-edited project. Formats either shape safely; never throws.
 *
 * Part 6 polish (2026-10): the separator now matches the EXACT string Notion's own date
 * round-trip produces (`knowledge_notion.py::_page_to_flat`, "\u2192" not an en dash) so the
 * display text never visibly changes once the background sync catches up. A range whose start
 * and end are the same single day collapses to just that one date instead of a redundant
 * "X \u2192 X". */
export function formatShootDates(value) {
  if (typeof value === "string") return value || null;
  if (value && typeof value === "object") {
    const { start, end } = value;
    if (start && end && end !== start) return `${start} \u2192 ${end}`;
    return start || end || null;
  }
  return null;
}
